import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCodeBlockStyle0 = cosmosIconCss;

const CosmosIconCodeBlock$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCodeBlock extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4fd9b5712a3daf37bf03a13c0b7e89bf3ef94527', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a8fd08ea7111a3cd24b61fc6a937b137c7f1c48d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'df852ab90ff73fabbf8d6ac73c5f8a6b38b8f668', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.32 5a.5.5 0 0 0-.48.36l-3.08 11a.5.5 0 0 0 .47.67h.46a.52.52 0 0 0 .49-.36l3.07-11a.5.5 0 0 0-.47-.67h-.46Zm6.41 5.65-3.39-3.39a.4.4 0 0 0-.28-.12.37.37 0 0 0-.27.11l-.44.44a.36.36 0 0 0-.11.26.44.44 0 0 0 .11.28L17.12 11l-2.77 2.77a.44.44 0 0 0-.11.28c0 .098.04.192.11.26l.44.44a.37.37 0 0 0 .27.11.4.4 0 0 0 .28-.12l3.39-3.39a.5.5 0 0 0 0-.7Zm-12.2 4.09-3.39-3.39a.48.48 0 0 1 0-.7l3.39-3.34a.4.4 0 0 1 .28-.12.37.37 0 0 1 .27.11l.44.44a.41.41 0 0 1 .11.26.4.4 0 0 1-.12.23L4.75 11l2.76 2.77a.4.4 0 0 1 .12.28.41.41 0 0 1-.11.26l-.44.44a.37.37 0 0 1-.27.11.4.4 0 0 1-.28-.12Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCodeBlockStyle0; }
}, [1, "cosmos-icon-code-block", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-code-block"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-code-block":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCodeBlock$1);
            }
            break;
    } });
}

const CosmosIconCodeBlock = CosmosIconCodeBlock$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCodeBlock, defineCustomElement };
